import { v4 } from "uuid";

import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  getAiChatSessionId,
  handleAiChatAction,
} from "@src/store/slices/aiChat";

/**
 * Returns the current Viv chat session id, minting and seeding one when the
 * chat hasn't started yet.
 *
 * The id is always client-generated — the chat endpoint requires a uuid in the
 * request body and creates the session row lazily on the first send (an id that
 * is never sent leaves no server-side trace), so seeding one early costs
 * nothing. `prepareChatMutation` picks up a pre-seeded id (`aiChat.sessionId ||
 * v4()`), which is what lets a pre-turn event be attributed to the chat the
 * turn goes on to create.
 *
 * Seeds via `setSessionId` rather than `initialize`: the latter resets the whole
 * chat state and claims a `workflowId`, which is the turn's job, not ours.
 */
export const ensureChatSessionId = createAsyncThunk<string, void>(
  "experienceBuilderAi/ensureChatSessionId",
  (_, { dispatch, getState }) => {
    const existing = getAiChatSessionId(getState());
    if (existing) return existing;
    const sessionId = v4();
    dispatch(handleAiChatAction([{ type: "setSessionId", sessionId }]));
    return sessionId;
  }
);
